// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Force slick dots to show on mobile */
.slick-dots {
  bottom: -30px !important;
}

.slick-dots li {
  margin: 0 !important;
}

.slick-dots li button:before {
  font-size: 10px;
  color: white !important;
  opacity: 0.4;
}

.slick-dots li.slick-active button:before {
  color: white !important;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/HOC/modal/InfoCardHome/infoCard.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ","sourcesContent":["/* Force slick dots to show on mobile */\n.slick-dots {\n  bottom: -30px !important;\n}\n\n.slick-dots li {\n  margin: 0 !important;\n}\n\n.slick-dots li button:before {\n  font-size: 10px;\n  color: white !important;\n  opacity: 0.4;\n}\n\n.slick-dots li.slick-active button:before {\n  color: white !important;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
